import React from 'react';
import styled from '@emotion/styled';

export const Paragraph = styled.div`
  display: inline-block;
`;
